import * as Matter from 'matter-js';

export interface PhysicsWorld {
  engine: Matter.Engine;
  world: Matter.World;
}

export interface CreatePhysicsWorldOptions {
  gravity?: { x: number; y: number };
}

export function createPhysicsWorld(opts: CreatePhysicsWorldOptions = {}): PhysicsWorld {
  const engine = Matter.Engine.create();
  engine.gravity.x = opts.gravity?.x ?? 0;
  engine.gravity.y = opts.gravity?.y ?? 1;
  return { engine, world: engine.world };
}
